import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { RootReducer } from "../../../components/app/reducer"
import Disclaimer from "../../../components/disclaimer"
import { Link } from "react-router-dom"
import { ResultsCl, TableHeader } from "../../../components/results-table-cl"
import { Security } from "../../../openapi/security"

const SecurityResults: React.FC = () => {
    const disclaimerAccepted = useSelector((state: RootReducer) => state.appReducer.blnAppDisclaimerAgreed);
    const securities = useSelector((state: RootReducer) => state.securityResultReducer.securities);
    const searchCriteria = useSelector((state: RootReducer) => state.securityResultReducer.securitiesSearchCriteria);
    const numberOfSecurities = useSelector((state: RootReducer) => state.securityResultReducer.securities?.length) || 0;
    const numberOfRows: number  = securities && securities.length > 0 ? securities[0].nbrOfRows || 0 : 0;

    useEffect(() => {
        document.title = "Search for Securities Results"
    }, [])  //The empty array means that the useEffect is gonna be called onMount only

    const headerData: TableHeader<Security> = { cmc: "Common Code", isin: "ISIN", secName: "Security Name", depCd: "Principal Agent/Transfer Agent", CBLSettleStatus: "EFS",  cffQualified: "CFF", taxCtry: "Tax Ctry", cbfCustTyp: "CEU Custody Type" }

    return (
        <div id="security-results">
            {/* Disclaimer will not render (retruns null) if accepted */}
            <Disclaimer />
            {disclaimerAccepted &&
                <>
                    <Link to="/securitycriteria">Back to Search Criteria</Link>
                    <p className="codelist-header"> Search for Securities Results </p>
                    <div>
                        <div>
                            Your query returned the following results. For more details about a specific security, please click on the code.
				        </div>
                    </div>
                    <div>
                        {numberOfSecurities === 1 ? <span> <span className="bold"> 1 </span> Security found. </span>
                                                  : <span> <span className="bold"> {numberOfRows} </span> Securities found. </span>
                        }    
                        {numberOfRows > 150 ? <span> Only <span className="bold"> 150 </span> displayed. Use download facility to get the complete list.</span> : ""}        
                    </div>
                    <ResultsCl recordsOnPage={10} header={headerData} data={securities} searchCriteria={searchCriteria}
                        urlCSV="/codelist/luxcsd/v1/SecurityLuxCSD/export/csv"
                        urlXML="/codelist/luxcsd/v1/SecurityLuxCSD/export/xml"
                        leadingColumnContent={
                            (item: Security) => (<Link to={`/security/${item.cmc}`}>{item.cmc}</Link>)
                        }
                        customColumnIndex={4}
                    />
                </>
            }
        </div>
    )
}

export default SecurityResults